import type { ColorVariants } from '@equinor/eds-core-react'
import type { ImageWithLastScan } from '../../../../store/scan-api'
import { getFetchErrorData } from '../../../../store/utils/parse-errors'

interface ScanStatus {
  label: string
  color?: ColorVariants
}

export const getScanStatus = (scan?: Readonly<ImageWithLastScan>): ScanStatus => {
  if (!scan) {
    return { label: 'No data' }
  }
  if (scan.scanSuccess === false) {
    return { label: 'Scan failed', color: 'warning' }
  }
  return { label: 'Not scanned' }
}

export const getFetchErrorMessage = (error: unknown): string => {
  const { code, message } = getFetchErrorData(error)
  return [code, message].filter((part) => !!part).join(': ')
}
